import { useQuery } from '@apollo/client';
import { GET_ROLE_USER } from '../graphql/Query/Signin.js';

const withSession = Component => props => {
  const { data, refetch } = useQuery(GET_ROLE_USER, { fetchPolicy: "cache-and-network" });
  return <Component {...props} session={data} refetch={refetch} />;
};

export default withSession;